import RapplerCarouxel from './components/RapplerCarouxel';

export default RapplerCarouxel;



// WEBPACK FOOTER //
// ./src/lib/index.js